import { Flex, Skeleton } from '@chakra-ui/react';
import { fetchFoldersEffect } from 'app/store/SongList/effects';
import { getFoldersNextLink } from 'app/store/SongList/selectors';
import { useInfiniteLoader } from 'app/utils/hooks';

export const useSongFoldersInfiniteLoader = ({
  dataLength,
}: {
  dataLength: number;
}) => {
  return useInfiniteLoader({
    listId: 'songsFolderListId',
    dataLength,
    nextLinkSelector: getFoldersNextLink,
    fetchNext: fetchFoldersEffect,
    LoaderComponent: (
      <Flex flexDir="column" gap="7px">
        {[...Array(5)].map((_, index) => (
          // eslint-disable-next-line react/no-array-index-key
          <Skeleton key={index} h={8} py={4} mx={2} />
        ))}
      </Flex>
    ),
  });
};
